import { FileSpreadsheet, FileJson } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { Button } from '@/components/ui/button';
import { Download, Loader2 } from 'lucide-react';
import type { PayrollExportFormat } from '@/services/payroll/payrollExportService';

interface PayrollExportButtonProps {
  onExport: (format: PayrollExportFormat) => void;
  isExporting?: boolean;
  variant?: 'default' | 'outline' | 'ghost' | 'sm';
  label?: string;
}

export function PayrollExportButton({
  onExport,
  isExporting = false,
  variant = 'outline',
  label = 'Export',
}: PayrollExportButtonProps) {
  if (isExporting) {
    return (
      <Button variant={variant === 'sm' ? 'outline' : variant} size={variant === 'sm' ? 'sm' : 'default'} disabled>
        <Loader2 className="h-4 w-4 mr-2 animate-spin" />
        Exporting...
      </Button>
    );
  }

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant={variant === 'sm' ? 'outline' : variant} size={variant === 'sm' ? 'sm' : 'default'}>
          <Download className="h-4 w-4 mr-2" />
          {label}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={() => onExport('csv')}>
          <FileSpreadsheet className="h-4 w-4 mr-2" />
          Export as CSV
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => onExport('json')}>
          <FileJson className="h-4 w-4 mr-2" />
          Export as JSON
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
